// import React, { useRef, useState } from "react";
// import "./Fmpayslips.css";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import {
//   Box,
//   Button,
//   Card,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
//   Paper,
//   TableContainer,
//   FormControl,
//   Select,
//   MenuItem,
//   InputLabel,
//   Divider,
// } from "@mui/material";
// import logo from "../../../assets/images/Picture2.png";

// const FinancePayslip = () => {
//   const pdfRef = useRef();
//   const [year, setYear] = useState("2024");
//   const [month, setMonth] = useState("January");

//   const downloadPDF = async () => {
//     const canvas = await html2canvas(pdfRef.current, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");
//     const pdf = new jsPDF("p", "mm", "a4");
//     const imgWidth = 190;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
//     pdf.save(`Payslip_${month}_${year}.pdf`);
//   };

//   return (
//     <>
//       {/* FILTER BAR */}
//       <div className="fp-filter-bar">
//         <FormControl size="small" className="fp-filter-control">
//           <InputLabel>Year</InputLabel>
//           <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
//             {[2022, 2023, 2024, 2025, 2026].map((y) => (
//               <MenuItem key={y} value={y}>{y}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         <FormControl size="small" className="fp-filter-control">
//           <InputLabel>Month</InputLabel>
//           <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
//             {[
//               "January","February","March","April","May","June",
//               "July","August","September","October","November","December",
//             ].map((m) => (
//               <MenuItem key={m} value={m}>{m}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </div>

//       {/* PAYSLIP */}
//       <Card ref={pdfRef} className="fp-payslip-card">
//         {/* HEADER */}
//         <div className="fp-header">
//           <img src={logo} alt="Company Logo" />
//           <div>
//             <h2>Envision Integrated Services Pvt. Ltd.</h2>
//             <p>CIN: U72200TG201PTC0903</p>
//             <p>Bengaluru, Karnataka</p>
//           </div>
//         </div>

//         <Divider />

//         <Typography className="fp-title">
//           PAY SLIP – {month.toUpperCase()} {year}
//         </Typography>

//         {/* EMPLOYEE INFO */}
//         <TableContainer component={Paper} className="fp-table-box">
//           <Table size="small">
//             <TableBody>
//               <TableRow>
//                 <TableCell><b>Employee Name</b></TableCell>
//                 <TableCell>Jon Doe</TableCell>
//                 <TableCell><b>Employee ID</b></TableCell>
//                 <TableCell>ENV-1021</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Designation</b></TableCell>
//                 <TableCell>Finance Manager</TableCell>
//                 <TableCell><b>Department</b></TableCell>
//                 <TableCell>Finance</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Location</b></TableCell>
//                 <TableCell>Bengaluru</TableCell>
//                 <TableCell><b>PAN</b></TableCell>
//                 <TableCell>ABCDE1234F</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Bank</b></TableCell>
//                 <TableCell>HDFC Bank</TableCell>
//                 <TableCell><b>Account No</b></TableCell>
//                 <TableCell>XXXXXX9876</TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* EARNINGS / DEDUCTIONS */}
//         <TableContainer component={Paper} className="fp-table-box">
//           <Table size="small">
//             <TableBody>
//               <TableRow className="fp-table-head">
//                 <TableCell>Earnings</TableCell>
//                 <TableCell>₹ Amount</TableCell>
//                 <TableCell>Deductions</TableCell>
//                 <TableCell>₹ Amount</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>Basic Salary</TableCell>
//                 <TableCell>43,333</TableCell>
//                 <TableCell>PF</TableCell>
//                 <TableCell>5,200</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>HRA</TableCell>
//                 <TableCell>17,333</TableCell>
//                 <TableCell>Income Tax</TableCell>
//                 <TableCell>16,589</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>Special Allowance</TableCell>
//                 <TableCell>45,619</TableCell>
//                 <TableCell>Professional Tax</TableCell>
//                 <TableCell>200</TableCell>
//               </TableRow>

//               <TableRow className="fp-total-row">
//                 <TableCell>Total Earnings</TableCell>
//                 <TableCell>1,06,285</TableCell>
//                 <TableCell>Total Deductions</TableCell>
//                 <TableCell>21,989</TableCell>
//               </TableRow>

//               <TableRow className="fp-netpay-row">
//                 <TableCell colSpan={3}><b>Net Pay</b></TableCell>
//                 <TableCell><b>₹ 84,296</b></TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Typography className="fp-footer-note">
//           * This is a system generated payslip and does not require signature.
//         </Typography>
//       </Card>

//       <Box textAlign="center" mt={3}>
//         <Button variant="contained" onClick={downloadPDF}>
//           Download Payslip PDF
//         </Button>
//       </Box>
//     </>
//   );
// };

// export default FinancePayslip;


// import React, { useState, useRef } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   TextField,
//   Modal,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import "./Fmpayslips.css";

// import companyLogo from "../../../assets/images/Picture2.png";

// /* ================= DEFAULT DATA ================= */

// const defaultEarnings = [
//   { name: "Basic Salary", amount: 43333 },
//   { name: "HRA", amount: 17333 },
//   { name: "Special Allowance", amount: 45619 },
// ];

// const defaultDeductions = [
//   { name: "PF", amount: 5200 },
//   { name: "Income Tax", amount: 16589 },
//   { name: "Professional Tax", amount: 200 },
// ];

// const PaySlipManager = () => {
//   const [paySlips, setPaySlips] = useState([
//     {
//       id: 1,
//       month: "January 2024",
//       employeeName: "Jon Doe",
//       employeeId: "ENV-1021",
//       designation: "Finance Manager",
//       department: "Finance",
//       location: "Bengaluru",
//       pan: "ABCDE1234F",
//       bankName: "HDFC Bank",
//       accountNo: "XXXXXX9876",
//       earnings: defaultEarnings,
//       deductions: defaultDeductions,
//       active: true,
//     },
//     {
//       id: 2,
//       month: "February 2024",
//       employeeName: "Jane Smith",
//       employeeId: "ENV-1022",
//       designation: "Senior Manager",
//       department: "Finance",
//       location: "Bengaluru",
//       pan: "ABCDE1234F",
//       bankName: "ICICI Bank",
//       accountNo: "XXXXXX4567",
//       earnings: defaultEarnings,
//       deductions: defaultDeductions,
//       active: false,
//     },
//   ]);

//   const [open, setOpen] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [formData, setFormData] = useState({
//     month: "",
//     employeeName: "",
//     employeeId: "",
//     designation: "",
//     department: "",
//     location: "",
//     pan: "",
//     bankName: "",
//     accountNo: "",
//     earnings: [...defaultEarnings],
//     deductions: [...defaultDeductions],
//   });

//   const payslipRef = useRef(null);

//   /* ================= HANDLERS ================= */

//   const handleOpen = () => {
//     setEditId(null);
//     setFormData({
//       month: "",
//       employeeName: "",
//       employeeId: "",
//       designation: "",
//       department: "",
//       location: "",
//       pan: "",
//       bankName: "",
//       accountNo: "",
//       earnings: [...defaultEarnings],
//       deductions: [...defaultDeductions],
//     });
//     setOpen(true);
//   };

//   const handleSave = () => {
//     if (!formData.month || !formData.employeeName) return;

//     if (editId) {
//       setPaySlips((prev) =>
//         prev.map((ps) =>
//           ps.id === editId ? { ...ps, ...formData } : ps
//         )
//       );
//     } else {
//       setPaySlips((prev) => [
//         ...prev,
//         {
//           id: Date.now(),
//           ...formData,
//           active: false,
//         },
//       ]);
//     }
//     setOpen(false);
//   };

//   const handleEdit = (ps) => {
//     setEditId(ps.id);
//     setFormData(ps);
//     setOpen(true);
//   };

//   const handleDelete = (id) => {
//     setPaySlips((prev) => prev.filter((ps) => ps.id !== id));
//   };

//   const handleUse = (id) => {
//     setPaySlips((prev) =>
//       prev.map((ps) => ({
//         ...ps,
//         active: ps.id === id,
//       }))
//     );
//   };

//   const activePaySlip = paySlips.find((ps) => ps.active);

//   const total = (arr) => arr.reduce((s, i) => s + Number(i.amount), 0);

//   /* ================= PDF ================= */

//   const downloadPDF = () => {
//     html2canvas(payslipRef.current, { scale: 2 }).then((canvas) => {
//       const img = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "pt", "a4");
//       const width = pdf.internal.pageSize.getWidth();
//       const height = (canvas.height * width) / canvas.width;
//       pdf.addImage(img, "PNG", 0, 0, width, height);
//       pdf.save(`${activePaySlip.employeeName}_Payslip.pdf`);
//     });
//   };

//   /* ================= JSX ================= */

//   return (
//     <Box sx={{ p: 2 }}>
//       {/* HEADER */}
//       <Box className="header">
//         <Typography variant="h5">Pay Slips</Typography>
//         <Button
//           variant="contained"
//           startIcon={<AddCircleOutlineIcon />}
//           onClick={handleOpen}
//         >
//           Create Pay Slip
//         </Button>
//       </Box>

//       <Box className="main-content">
//         {/* LEFT CARDS */}
//         <Box className="left-panel">
//           {paySlips.map((ps) => (
//             <Paper
//               key={ps.id}
//               className={`paySlipCard ${ps.active ? "active" : ""}`}
//             >
//               <Box>
//                 <Typography fontWeight={600}>{ps.month}</Typography>
//                 <Typography variant="body2">{ps.employeeName}</Typography>
//                 <Typography variant="caption">{ps.designation}</Typography>
//               </Box>

//               <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//   <Button
//     size="small"
//     variant={ps.active ? "contained" : "outlined"}
//     onClick={() => handleUse(ps.id)}
//   >
//     Use
//   </Button>
//   <IconButton onClick={() => handleEdit(ps)}>
//     <EditIcon fontSize="small" />
//   </IconButton>
//   <IconButton onClick={() => handleDelete(ps.id)}>
//     <DeleteIcon fontSize="small" />
//   </IconButton>
// </Box>

//             </Paper>
//           ))}
//         </Box>

//         {/* RIGHT PAYSLIP */}
//         <Box className="right-panel">
//           {activePaySlip && (
//             <>
//               <Paper className="payslip" ref={payslipRef}>
//                 <Box className="company-header">
//                   <img src={companyLogo} alt="logo" className="logo" />
//                   <Box>
//                     <Typography fontWeight={600}>
//                       Envision Integrated Services Pvt. Ltd.
//                     </Typography>
//                     <Typography variant="caption">
//                       Bengaluru, Karnataka
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Typography className="payslip-title">
//                   PAY SLIP – {activePaySlip.month}
//                 </Typography>

//                 <Table size="small" className="employee-info">
//                   <TableBody>
//                     <TableRow>
//                       <TableCell><b>Name</b></TableCell>
//                       <TableCell>{activePaySlip.employeeName}</TableCell>
//                       <TableCell><b>ID</b></TableCell>
//                       <TableCell>{activePaySlip.employeeId}</TableCell>
//                     </TableRow>
//                     <TableRow>
//                       <TableCell><b>Designation</b></TableCell>
//                       <TableCell>{activePaySlip.designation}</TableCell>
//                       <TableCell><b>Department</b></TableCell>
//                       <TableCell>{activePaySlip.department}</TableCell>
//                     </TableRow>
//                   </TableBody>
//                 </Table>

//                 <Box className="salary-section">
//                   <Paper className="earnings">
//                     <Typography className="table-title">Earnings</Typography>
//                     <Table size="small">
//                       <TableBody>
//                         {activePaySlip.earnings.map((e, i) => (
//                           <TableRow key={i}>
//                             <TableCell>{e.name}</TableCell>
//                             <TableCell>₹ {e.amount}</TableCell>
//                           </TableRow>
//                         ))}
//                         <TableRow>
//                           <TableCell><b>Total</b></TableCell>
//                           <TableCell><b>₹ {total(activePaySlip.earnings)}</b></TableCell>
//                         </TableRow>
//                       </TableBody>
//                     </Table>
//                   </Paper>

//                   <Paper className="deductions">
//                     <Typography className="table-title">Deductions</Typography>
//                     <Table size="small">
//                       <TableBody>
//                         {activePaySlip.deductions.map((d, i) => (
//                           <TableRow key={i}>
//                             <TableCell>{d.name}</TableCell>
//                             <TableCell>₹ {d.amount}</TableCell>
//                           </TableRow>
//                         ))}
//                         <TableRow>
//                           <TableCell><b>Total</b></TableCell>
//                           <TableCell><b>₹ {total(activePaySlip.deductions)}</b></TableCell>
//                         </TableRow>
//                       </TableBody>
//                     </Table>
//                   </Paper>
//                 </Box>

//                 <Box className="net-pay">
//                   <Typography fontWeight={600}>
//                     Net Pay: ₹{" "}
//                     {total(activePaySlip.earnings) -
//                       total(activePaySlip.deductions)}
//                   </Typography>
//                 </Box>
//               </Paper>

//               <Button sx={{ mt: 2 }} variant="contained" onClick={downloadPDF}>
//                 Download PDF
//               </Button>
//             </>
//           )}
//         </Box>
//       </Box>

//       {/* MODAL */}
//       <Modal open={open} onClose={() => setOpen(false)}>
//         <Box className="ssa-modal">
//           <Typography variant="h6" mb={2}>
//             {editId ? "Edit Pay Slip" : "Create Pay Slip"}
//           </Typography>

//           <div className="ssa-grid">
//             {[
//               "month",
//               "employeeName",
//               "employeeId",
//               "designation",
//               "department",
//               "location",
//               "pan",
//               "bankName",
//               "accountNo",
//             ].map((f) => (
//               <TextField
//                 key={f}
//                 label={f}
//                 size="small"
//                 value={formData[f]}
//                 onChange={(e) =>
//                   setFormData({ ...formData, [f]: e.target.value })
//                 }
//               />
//             ))}
//           </div>

//           <Button sx={{ mt: 2 }} variant="contained" onClick={handleSave}>
//             Save Pay Slip
//           </Button>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default PaySlipManager;



import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./Fmpayslips.css";

import companyLogo from "../../../assets/images/Picture2.png";

/* ================= DEFAULT DATA ================= */

const defaultEarnings = [
  { name: "Basic Salary", amount: 43333 },
  { name: "HRA", amount: 17333 },
  { name: "Special Allowance", amount: 45619 },
];

const defaultDeductions = [
  { name: "PF", amount: 5200 },
  { name: "Income Tax", amount: 16589 },
  { name: "Professional Tax", amount: 200 },
];

const PaySlipManager = () => {
  const [paySlips, setPaySlips] = useState([
    {
      id: 1,
      month: "January 2024",
      employeeName: "John Doe",
      employeeId: "EMP-101",
      designation: "Finance Manager",
      department: "Finance",
      earnings: defaultEarnings,
      deductions: defaultDeductions,
      active: true,
    },
    {
      id: 2,
      month: "February 2024",
      employeeName: "Jane Smith",
      employeeId: "EMP-102",
      designation: "Senior Accountant",
      department: "Finance",
      earnings: defaultEarnings,
      deductions: defaultDeductions,
      active: false,
    },
  ]);

  const [formData, setFormData] = useState({
    month: "",
    employeeName: "",
    employeeId: "",
    designation: "",
    department: "",
    location: "",
    pan: "",
    bankName: "",
    accountNo: "",
    earnings: [...defaultEarnings],
    deductions: [...defaultDeductions],
  });



  /* ================= HANDLERS ================= */

  const handleOpen = () => {
    setEditId(null);
    setFormData({
      month: "",
      employeeName: "",
      employeeId: "",
      designation: "",
      department: "",
      location: "",
      pan: "",
      bankName: "",
      accountNo: "",
      earnings: [...defaultEarnings],
      deductions: [...defaultDeductions],
    });
    setOpen(true);
  };

  const [open, setOpen] = useState(false);
  const payslipRef = useRef(null);

  const [editId, setEditId] = useState(null);

  const activePaySlip = paySlips.find((p) => p.active);

  const total = (arr) => arr.reduce((s, i) => s + Number(i.amount), 0);

  const handleUse = (id) => {
    setPaySlips((prev) =>
      prev.map((p) => ({ ...p, active: p.id === id }))
    );
  };

  const downloadPDF = () => {
    html2canvas(payslipRef.current, { scale: 2 }).then((canvas) => {
      const img = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;
      pdf.addImage(img, "PNG", 0, 0, width, height);
      pdf.save("Payslip.pdf");
    });
  };

  const handleSave = () => {
    if (!formData.month || !formData.employeeName) return;

    if (editId) {
      setPaySlips((prev) =>
        prev.map((ps) =>
          ps.id === editId ? { ...ps, ...formData } : ps
        )
      );
    } else {
      setPaySlips((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...formData,
          active: false,
        },
      ]);
    }
    setOpen(false);
  };

  const handleEdit = (ps) => {
    setEditId(ps.id);
    setFormData(ps);
    setOpen(true);
  };

  const handleDelete = (id) => {
    setPaySlips((prev) => prev.filter((ps) => ps.id !== id));
  };



  return (
    <Box className="page-wrapper">
      {/* HEADER */}
      <Box className="header">
        <Typography variant="h5">Pay Slips</Typography>
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setOpen(true)}
        >
          Create Pay Slip
        </Button>
      </Box>

      <Box className="main-content">
        {/* LEFT PANEL – COLUMN ONLY */}
        <Box className="left-panel">
          {paySlips.map((ps) => (
            <Paper
              key={ps.id}
              className={`paySlipCard ${ps.active ? "active" : ""}`}
            >
              <Box>
                <Typography fontWeight={600}>{ps.month}</Typography>
                <Typography variant="body2">{ps.employeeName}</Typography>
                <Typography variant="caption">{ps.designation}</Typography>
              </Box>

              <Box className="card-actions">
                <Button
                  size="small"
                  variant={ps.active ? "contained" : "outlined"}
                  onClick={() => handleUse(ps.id)}
                  sx={{
                    minHeight: "26px",
                    height: "26px",
                    padding: "2px 10px",
                    fontSize: "12px",
                    lineHeight: 1,
                  }}
                >
                  Use
                </Button>

                <IconButton size="small">
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton size="small">
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </Paper>
          ))}
        </Box>

        {/* RIGHT PANEL – PAYSLIP */}
        <Box className="right-panel">
          {activePaySlip && (
            <>
              <Paper className="payslip" ref={payslipRef}>
                <Box className="company-header">
                  <img src={companyLogo} alt="logo" className="logo" />
                  <Box>
                    <Typography fontWeight={600}>
                      Envision Integrated Services Pvt. Ltd.
                    </Typography>
                    <Typography variant="caption">
                      Bengaluru, Karnataka
                    </Typography>
                  </Box>
                </Box>

                <Typography className="payslip-title">
                  PAY SLIP – {activePaySlip.month}
                </Typography>

                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>{activePaySlip.employeeName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Employee ID</TableCell>
                      <TableCell>{activePaySlip.employeeId}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Designation</TableCell>
                      <TableCell>{activePaySlip.designation}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>

                <Box className="salary-section">
                  <Box className="earnings">
                    <Typography className="table-title">Earnings</Typography>
                    {activePaySlip.earnings.map((e, i) => (
                      <div key={i} className="salary-row">
                        <span>{e.name}</span>
                        <span>₹ {e.amount}</span>
                      </div>
                    ))}
                  </Box>

                  <Box className="deductions">
                    <Typography className="table-title">Deductions</Typography>
                    {activePaySlip.deductions.map((d, i) => (
                      <div key={i} className="salary-row">
                        <span>{d.name}</span>
                        <span>₹ {d.amount}</span>
                      </div>
                    ))}
                  </Box>
                </Box>

                <Box className="net-pay">
                  Net Pay: ₹{" "}
                  {total(activePaySlip.earnings) -
                    total(activePaySlip.deductions)}
                </Box>
              </Paper>

              <Button
                sx={{ mt: 2 }}
                variant="contained"
                onClick={downloadPDF}
              >
                Download PDF
              </Button>
            </>
          )}
        </Box>
      </Box>

      {/* MODAL */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box className="ssa-modal">
          <Typography variant="h6" mb={2}>
            {editId ? "Edit Pay Slip" : "Create Pay Slip"}
          </Typography>

          <div className="ssa-grid">
            {[
              "month",
              "employeeName",
              "employeeId",
              "designation",
              "department",
              "location",
              "pan",
              "bankName",
              "accountNo",
            ].map((f) => (
              <TextField
                key={f}
                label={f}
                size="small"
                value={formData[f]}
                onChange={(e) =>
                  setFormData({ ...formData, [f]: e.target.value })
                }
              />
            ))}
          </div>

          <Button sx={{ mt: 2 }} variant="contained" onClick={handleSave}>
            Save Pay Slip
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default PaySlipManager;
